const IconWarning = ({ size, style = {} }) => (
  <svg
    width={size === 'small' ? 16 : 20}
    height={size === 'small' ? 16 : 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.72494 17.0865C2.4416 17.0865 1.6416 15.6948 2.28327 14.5865L8.55827 3.74482C9.19994 2.63649 10.7999 2.63649 11.4416 3.74482L17.7166 14.5865C18.3583 15.6948 17.5583 17.0865 16.2749 17.0865H3.72494ZM16.2749 15.4198L9.99994 4.57816L3.72494 15.4198H16.2749ZM9.1666 8.75316V10.4198C9.1666 10.8782 9.5416 11.2532 9.99994 11.2532C10.4583 11.2532 10.8333 10.8782 10.8333 10.4198V8.75316C10.8333 8.29482 10.4583 7.91982 9.99994 7.91982C9.5416 7.91982 9.1666 8.29482 9.1666 8.75316ZM10.8333 14.5865V12.9198H9.1666V14.5865H10.8333Z"
      fill="#F44336"
    />
  </svg>
);

export default IconWarning;
